<template>
  <div class="about" v-if="data">
    <div class="container full-width-outer hero" v-bind:style="{backgroundImage: backgroundUrl}">
      <div class="header-spacer"></div>
      <!-- <div class="overlay"></div> -->
      <div class="row row-center">
        <transition name="slide" appear v-if="show">
        <!-- <div class="column column-50 index-cta"> -->
        <div class="column column-60">
          <!-- <div class="vert-center"> -->
  
              <div class="cta-inner">
                <div class="heading-wrap rounded-border"><h1 class="has-color-initial" style="text-align: center;">{{ data.title }}</h1></div>
              
              <div v-for="c in data.content" v-bind:key="c.value" class="column has-color-initial">
                <div v-html="c.value" class="size-2 size-500"></div>
              </div>
              </div>
        </div>
        </transition>
        <div class="column">
        <!-- <div class="column no-padding index-image" v-bind:style="{backgroundImage: 'url('+data.hero_image_top.url+')'}"> -->
             <!-- <img :src='data.hero_image_top.url' v-if='data.hero_image_top'> -->
        </div>
      </div>
    </div>

    <div v-if="data.search">
      <div v-if="data.search.length > 0">
        <SearchBlock :searchItems="data.search" :pageType='data.meta.type' @filterChange='handleFilter'/>
      </div>
    </div>
    <!-- <div id="grouped-items" class="container">
      <div class="row row-wrap">
        <div v-for="gp in grouped_pages" v-bind:key='gp.id' class="column column-33" style="margin: 5px 0px 0; text-align: center;"> -->
          <!-- display an image -->
          <!-- <div style="width: 300px; height: 100px; outline: thin pink solid;">Image: {{ gp.hero_image_id }} should display here</div> -->
          <!-- <router-link :to="{ path: gp.url_path}">
            <img v-if="gp.thumbnail" :src="gp.thumbnail.url">
            <p>{{ gp.title }}</p>
          </router-link>
          <p>{{ gp.starting_at }}</p>
          <p>{{ gp.relative_price }}</p>
          <p v-if="gp.website"><a v-bind:href="gp.website" target="_blank">Website</a></p>
          <p v-for='link in gp.other_links' v-bind:key="link.id"><a v-bind:href="link.url" target="_blank">{{ link.link_text }}</a></p>
        </div>
      </div>
    </div> -->
    <Pagination :pageType='"pages.BasicPage"' :limit='21' :fields='["*"]' :filters='send_filter' :order='"title"' :group_by_nodes='true'/>
  </div>
</template>

<script>
// import TopMenu from '@/components/TopMenu.vue'
import SearchBlock from '@/components/SearchBlock.vue'
import Pagination from '@/components/Pagination.vue'
import axios from 'axios'
export default{
  name: 'GroupedPage',
  data(){
    return{
      data: null,
      filter_array: [],
      show: true,
      // grouped_pages: [],
      pagiFilter: []
    }
  },
  components: {
    // TopMenu,
    SearchBlock,
    Pagination,
  },
  computed: {
    group_by_nodes: function() {
      let nodes = []
      for (let i in this.data.node) {
        nodes.push(this.data.node[i].id)
      }
      return nodes.toString();
    },
    persistent_filter: function() {
      let filter = [];
      for (let i in this.data.node) {
        filter.push({'type': 'node', 'value': this.data.node[i].id, 'orGroup': 0})
      }
      return filter
    },
    send_filter: function() {
      return this.persistent_filter.concat(this.pagiFilter)
    },
    backgroundUrl: function() {
      let url = ''
      if (this.data.hero_image) {
        url = 'url('+this.data.hero_image.url+')';
      }
      return url;
    },
  },
  created (){
    this.fetchData().then(data =>{
      this.data = data
      // this.grouped_pages = data.grouped_pages
      if (this.data.custom_styles) {
        let styles = document.createElement('style');
        styles.type = 'text/css';
        styles.id = 'temp-styles';
        for (let d in this.data.custom_styles) {
          if (!this.data.custom_styles[d].value.hide) {
            styles.appendChild(document.createTextNode(this.data.custom_styles[d].value.style));
          }
        }
        document.getElementsByTagName("head")[0].appendChild(styles);
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    setTimeout(function (){
    next(vm => {
      // access to component instance via `vm`
      vm.show = true
    })
    }, 300)
  },
  beforeRouteLeave (to, from, next){
       console.log('b4 route leave')
    this.show = false
    this.currentDateFilter = null;
    // next();
    setTimeout(function (){
      next()
    }, 250)
    if (this.data.custom_styles) {
      let tempSty = document.getElementById('temp-styles');
      if (tempSty) {
        tempSty.remove();
      }
    }
    next();
  },
  watch:{
    $route (to, from){
      this.fetchData().then(data =>{
        this.data = data
        // this.grouped_pages = data.grouped_pages
      })
    }
  },
  methods:{
    fetchData(){
       var id = this.$route.meta.id
       return axios.get('/api/v2/pages/'+id).then(response => {
        //  console.log(JSON.stringify(response))
         return response.data
       })
    },
    handleFilter(filter_array){
      let newFilterQuery = [];
      for (let array in filter_array) {
        for (let filter in filter_array[array]) {
          newFilterQuery.push({'type': 'node', 'value': filter_array[array][filter], 'orGroup': Number(array)+1});
        }
      }
      this.pagiFilter = newFilterQuery;
      // this.filter_array = filter_array;
      // var temp_grouped_pages = this.data.grouped_pages;
      // var empty_filters = [];
      // for (var filter in filter_array) {
      //   if (filter_array[filter].length > 0) {
      //   temp_grouped_pages = temp_grouped_pages.filter(page => {
      //     var intersection =  page.node_data.filter(x => filter_array[filter].includes(x.id));
      //     if (intersection.length > 0){
      //       return true;
      //     }
      //     return false;
      //     })
      //   } else {
      //     empty_filters.push('true');
      //   }
      // }
      // if (empty_filters.length == filter_array.length) {
      //   temp_grouped_pages = this.data.grouped_pages;
      // }

      // this.grouped_pages = temp_grouped_pages

      // if (this.filter.length > 0){
      //   this.grouped_pages = this.data.grouped_pages.filter(page => {
      //     var intersection =  page.node_list.filter(x => this.filter.includes(x))
      //     //// Exclusive search: All filter items must mach for item to show up
      //     // if (intersection.length == this.filter.length){
      //     //   return true
      //     // }
      //     //// Inclusive search: If at least one filter item matches it will show up
      //     if (intersection.length > 0){
      //       return true
      //     }
      //     return false
      //     })
      // } else {
      //   this.grouped_pages = this.data.grouped_pages
      // }

    }
  }

}
</script>

<style scoped>
 .hero{
    position: relative;
    z-index: 2;
    background: #fff
  }

  .hero .row{
    min-height: 550px;
    flex-direction: row;
  }

    
  .slide-enter-active, .slide-leave-active{
    transition: all .5s;
  }

  .slide-enter, .slide-leave-to{
    transform: translateX(-150%);
    opacity: .5;
  }
</style>